import { AppLayout } from "@/components/layout/AppLayout";
import { isDepartmentId, listDepartments } from "@/grid/config/registry";
import { DepartmentTargetsNav } from "@/targets/components/DepartmentTargetsNav";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export function TargetLayout() {
  const navigate = useNavigate();
  const { departmentId = "sales" } = useParams<{ departmentId: string }>();
  const departments = listDepartments();
  const activeDepartmentId = isDepartmentId(departmentId) ? departmentId : "sales";

  return (
    <AppLayout contentClassName="px-4 pb-8 sm:px-6">
      <div className="mx-auto flex min-h-[calc(100dvh-4rem)] max-w-[1400px] gap-6 py-4">
        <aside className="hidden w-52 shrink-0 md:block">
          <p className="mb-3 px-3 text-xs font-semibold uppercase tracking-wide text-[var(--color-text-muted)]">
            Departments
          </p>
          <DepartmentTargetsNav />
        </aside>

        <main className="min-w-0 flex-1">
          <div className="mb-4 flex flex-wrap items-center gap-3 md:hidden">
            <Select value={activeDepartmentId} onValueChange={(id) => navigate(`/targets/${id}`)}>
              <SelectTrigger className="min-w-40">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {departments.map((department) => (
                  <SelectItem key={department.id} value={department.id}>
                    {department.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Outlet />
        </main>
      </div>
    </AppLayout>
  );
}
